import { getCustomer } from "@/graphql/schemas/shared/utils/getCustomer"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { createCustomerCart } from "../utils/createCart"

export const mutationCreateCustomerCart = {
  async createCustomerCart(parent, args, context, info) {
    let { customerId, customerKey, cartKey, currency, country, origin } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.CARTS,
      operation: Operations.CREATE,
    })
    const customer = await getCustomer({ id: customerId, key: customerKey })

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })

    try {
      const cart = await createCustomerCart(customer, cartKey, currency, country, origin, user)

      return cart
    } catch (err) {
      // instead of returning null, catch errors
      throw new Error(err)
    }
  },
}
